const UI_START_LOADING = "jangl/loader/UI_START_LOADING";
const UI_STOP_LOADING = "jangl/loader/UI_STOP_LOADING";

export { UI_START_LOADING, UI_STOP_LOADING };
